import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UruguayFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_16157'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_16157)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20 1.8667H9.52381V3.73337H20V1.8667ZM9.52381 5.60003V7.4667H20V5.60003H9.52381ZM9.52381 9.33337L0 9.33336V11.2H20V9.33337H9.52381ZM0 14V13.0667H20V14H0Z'
					fill='#0E4DC5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.76144 6.5249L4.12567 7.45496L3.96462 6.34667L2.98004 6.91429L3.32563 5.84728L2.18724 5.94003L2.97101 5.12564L1.9043 4.72516L2.97101 4.32468L2.18724 3.51029L3.32563 3.60304L2.98004 2.53603L3.96462 3.10365L4.12567 1.99536L4.76144 2.92542L5.39721 1.99536L5.55826 3.10365L6.54284 2.53603L6.19725 3.60304L7.33564 3.51029L6.55187 4.32468L7.61858 4.72516L6.55187 5.12564L7.33564 5.94003L6.19725 5.84728L6.54284 6.91429L5.55826 6.34667L5.39721 7.45496L4.76144 6.5249ZM4.76144 6.50698C5.76559 6.50698 6.57962 5.70923 6.57962 4.72516C6.57962 3.74109 5.76559 2.94334 4.76144 2.94334C3.75729 2.94334 2.94326 3.74109 2.94326 4.72516C2.94326 5.70923 3.75729 6.50698 4.76144 6.50698ZM6.19001 4.66666C6.19001 5.43986 5.55042 6.06666 4.76144 6.06666C3.97246 6.06666 3.33287 5.43986 3.33287 4.66666C3.33287 3.89346 3.97246 3.26666 4.76144 3.26666C5.55042 3.26666 6.19001 3.89346 6.19001 4.66666Z'
					fill='#FED443'
				/>
			</g>
		</svg>
	);
};

export default UruguayFlagIcon;
